import React from 'react';
import { useSelector } from '@bridebook/web/lib/utils';
import {
  getIsShowroundModalOpen,
  getShowroundSupplierContextId,
} from '@bridebook/web/lib/showrounds/state';
import LoadingSpinner from '@bridebook/web/components/common/loading-spinner/loading-spinner';
import { ShowroundProvider } from '@bridebook/web/lib/showrounds/context/showround-context';

const ShowroundModalLazy = React.lazy(() =>
  import('./showround-modal').then((module) => ({ default: module.ShowroundModal })),
);

const ShowroundModal = () => {
  const isModalOpen = useSelector(getIsShowroundModalOpen);
  const supplierId = useSelector(getShowroundSupplierContextId);

  if (!isModalOpen || !supplierId) {
    return null;
  }

  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <ShowroundProvider supplierId={supplierId}>
        <ShowroundModalLazy />
      </ShowroundProvider>
    </React.Suspense>
  );
};

export default ShowroundModal;
